export const TOKEN = "token"
export const USERNAME = "username"
export const SETUPPAYPASS = "setuppaypass"
export const SYSTYPE = "sysType"



// WEBPACK FOOTER //
// ./src/custom/constants.js